import { ReactNode, useMemo } from 'react';

export interface FormattedDateTimeProps extends Intl.DateTimeFormatOptions {
  children: ReactNode;
  locales?: string[] | string;
}

export function getFormatted(children: ReactNode, props: FormattedDateTimeProps) {
  if (typeof children === 'string' && !Number.isNaN(Date.parse(children))) {
    const formatter = Intl.DateTimeFormat(props.locales, {
      ...props,
    });
    // ISO dates (ie. in the format of 2023-01-01), have a weird timezone
    // issue and need to be accounted for
    const date = new Date(/\d{4}-\d{2}-\d{2}/.test(children) ? `${children}T00:00:00` : children);
    return formatter.format(date);
  } else {
    return children;
  }
}

export const FormattedDateTime = ({ locales = 'en-us', ...props }: FormattedDateTimeProps) => {
  const { children } = props;

  const formatted = useMemo(() => {
    return getFormatted(children, { locales, ...props });
  }, [children, locales, props]);

  return <>{formatted}</>;
};

export default FormattedDateTime;
